import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function appSearchReducer(state = initialState.appSearch, action) {
  switch (action.type) {
    case types.SET_SEARCH_OPEN_FLAG:
      return Object.assign({}, state, {
        isSearchActive: action.isSearchActive,
      });
    case types.SET_APP_SEARCH_DATA_COLUMNS:
      return Object.assign({}, state, {
        columns: action.columns,
        pageId: action.pageId,
      });

    case types.SET_ACTIVE_STAGE_INDICATOR_SETTINGS_OPEN_FLAG:
      return {
        ...state,
        isActiveStageIndicatorSettingsEnabled: action.isActiveStageIndicatorSettingsEnabled,
      };
    default:
      return state;
  }
}
